import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import { BaseModalContentsWrapper } from '../../../components/BaseModalContentsWrapper';
export const SingleRowContainer = styled.div `
    display: flex;
    width: 100%;
`;
export const Container = styled(BaseModalContentsWrapper) `
    display: flex;
`;
export const PackshotHolder = styled.div `
    transition: transform ease 200ms;
    cursor: pointer;
    &:hover {
        transform: scale(${isMobile ? 1 : 1.1});
    }
    & img {
        border: ${({ isCurrentlyPlaying }) => isCurrentlyPlaying ? '4px solid #fabc0b' : 'none'} !important;
    }
`;
//# sourceMappingURL=index.js.map